import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ShaderMaterial, Uniform } from "three";
var fragment = "uniform sampler2D inputBuffer;\r\nuniform float opacity;\r\n\r\nvarying vec2 vUv;\r\n\r\nvoid main() {\r\n\r\n\tvec4 texel = texture2D(inputBuffer, vUv);\r\n\tgl_FragColor = opacity * texel;\r\n\r\n}\r\n";
var vertex = "varying vec2 vUv;\r\n\r\nvoid main() {\r\n\r\n\tvUv = uv;\r\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n\r\n}\r\n";
/**
 * A simple copy shader material.
 */

export var CopyMaterial =
/*#__PURE__*/
function (_ShaderMaterial) {
  _inherits(CopyMaterial, _ShaderMaterial);

  /**
   * Constructs a new copy material.
   */
  function CopyMaterial() {
    _classCallCheck(this, CopyMaterial);

    return _possibleConstructorReturn(this, _getPrototypeOf(CopyMaterial).call(this, {
      type: "CopyMaterial",
      uniforms: {
        inputBuffer: new Uniform(null),
        opacity: new Uniform(1.0)
      },
      fragmentShader: fragment,
      vertexShader: vertex,
      depthWrite: false,
      depthTest: false
    }));
  }

  return CopyMaterial;
}(ShaderMaterial);